import type { ColTypeDef } from 'ag-grid-community';
import { agMultiColumnFilter } from 'components/shared/Blotter/Grid/Hooks/utils';
import { useMemo } from 'react';

import { CurrencyCellRenderer } from '../CellRenderers';

export function useClientSideCurrencyColumnType<T>(handleValuesUpdate: boolean = false): ColTypeDef<T> {
  return useMemo(
    () => ({
      cellRenderer: CurrencyCellRenderer,
      ...agMultiColumnFilter(handleValuesUpdate),
    }),
    [handleValuesUpdate],
  );
}
export function useServerSideCurrencyColumnType<T>(): ColTypeDef<T> {
  return useMemo(
    () => ({
      cellRenderer: CurrencyCellRenderer,
    }),
    [],
  );
}
